import { useContext } from "react";
import { SocketContext } from "../contexts/useSubscriptions";

const UseFeedGetMatchingColumns = () => {
  const { getMatchingColumnsCompleted, setGetMatchingColumnsCompleted } =
    useContext(SocketContext);

  return {
    getMatchingColumnsCompleted,
    setGetMatchingColumnsCompleted,
  };
};
export default UseFeedGetMatchingColumns;
